var React = require('react');

function Indoor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #010101;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("polyline",{"className":"cls-1","points":"8.84 14.58 8.84 69 76.87 69 76.87 14.85","key":0}),React.createElement("polyline",{"className":"cls-1","points":".33 17.98 42.85 .97 85.37 18.32","key":1}),React.createElement("polyline",{"className":"cls-1","points":"30.8 28.14 36.09 50.97 31.06 69.03","key":2}),React.createElement("polyline",{"className":"cls-1","points":"36.09 50.97 54.91 50.97 54.91 69.02","key":3})])]);
}

Indoor.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 85.71 69.9"};

module.exports = Indoor;

Indoor.default = Indoor;
